
import {objectify} from "radash";
import md from "./metaData";
import {parseDate} from "./utils";
import {value} from "lodash/seq";



function * typeRules(adata) {

    for(const r of adata.typeRules.split(":")) {

        const [ruleName, ...ruleArgs] = r.split(",")

        yield ["renderValue", value => value]
        yield ["renderWarning", value => null]
        yield ["defaultDate", visit_date => new Date(parseDate(visit_date))]
        yield ["errorMsgIfAbsent", value => null]


        if(adata.type.startsWith("date")) {
            yield [
                "warnIfFuture",
                (value, ref, msg) => ref < value ? msg: null
            ]
        }
        else {
            yield [
                "warnIfFuture",
                (value, ref, msg) => null
            ]
        }

        switch (ruleName) {
            case "":
                break
            case "failIfAbsent":
                yield [
                    "errorMsgIfAbsent",
                    value => value ? null : ruleArgs[0]
                ]
                break
            case "futureOk":
                yield [
                    "warnIfFuture",
                    (value, ref, msg) => null
                ]
                break
            case "warnIfAbsent":
                yield [
                    "renderWarning",
                    value => value ? '' : "svp choisir"
                ]
                break;
            case "hintIfAbsent":
                yield [
                    "renderWarning",
                    value => value ? '' : ruleArgs[0]
                ]
                yield [
                    "renderValue",
                    value => value ? '' : ruleArgs[0]
                ]
                break;
            case "errorIfFormatInvalid":
                yield [
                    "errorIfFormatInvalid",
                    value => {
                        if(!value) {
                            return "spécifier"
                        }
                        const regex = /^[A-Za-z]\d[A-Za-z]$/

                        if(regex.test(value)) {
                            return null
                        }

                        return "le format doit être: A1A"
                    }
                ]
                default:
                    console.log(`unknown rule '${ruleName}'`);
        }
    }
}

export const initAdataRules = row => ({
    ...row,
    additionalData: row.additionalData.map(
        adata => {

            return {
                ...adata,
                typeRules: objectify(
                    [...typeRules(adata)],
                    a => a[0],
                    a => a[1],
                )
            }
        }
    )
})


const buildObervationTypeById = () => {


    function* trav(children, depth) {
        for (const row of children) {

            if (depth < 3) {
                yield* trav(row.children, depth + 1)
            }
            else {
                yield initAdataRules(row)
            }
        }
    }

    return objectify([...trav(md.children, 0)], r => r.id)
}



export const questionnaire = md


export const obervationTypeById = buildObervationTypeById()